module.exports = __webpack_public_path__ + "img/miccai2025worshop.878b2a29.png";